import React, { Component } from 'react';
import PropTypes from 'prop-types';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

var DefaultErrorComponent = /*#__PURE__*/function (_Component) {
  _inherits(DefaultErrorComponent, _Component);

  var _super = _createSuper(DefaultErrorComponent);

  function DefaultErrorComponent() {
    _classCallCheck(this, DefaultErrorComponent);

    return _super.apply(this, arguments);
  }

  _createClass(DefaultErrorComponent, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "error"
      }, /*#__PURE__*/React.createElement("div", null, "An Error Occurred"), /*#__PURE__*/React.createElement("div", null, this.error), /*#__PURE__*/React.createElement("div", null, this.info));
    }
  }]);

  return DefaultErrorComponent;
}(Component);

var HoneyBadgerErrorBoundary = /*#__PURE__*/function (_Component2) {
  _inherits(HoneyBadgerErrorBoundary, _Component2);

  var _super2 = _createSuper(HoneyBadgerErrorBoundary);

  function HoneyBadgerErrorBoundary(props) {
    var _this;

    _classCallCheck(this, HoneyBadgerErrorBoundary);

    _this = _super2.call(this, props);
    _this.state = {
      error: null,
      info: null,
      errorOccurred: false
    };
    return _this;
  }

  _createClass(HoneyBadgerErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, info) {
      this.setState({
        errorOccurred: true,
        error: error,
        info: info
      });
      this.props.honeybadger.notify(error, {
        context: info
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.errorOccurred) {
        var ErrorComponent = this.props.ErrorComponent;
        return ErrorComponent ? /*#__PURE__*/React.createElement(ErrorComponent, this.state) : /*#__PURE__*/React.createElement(DefaultErrorComponent, null);
      } else {
        return this.props.children;
      }
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError(error) {
      return {
        errorOccurred: true,
        error: error
      };
    }
  }]);

  return HoneyBadgerErrorBoundary;
}(Component);

_defineProperty(HoneyBadgerErrorBoundary, "propTypes", {
  honeybadger: PropTypes.object,
  children: PropTypes.element,
  ErrorComponent: PropTypes.oneOfType([PropTypes.element, PropTypes.func])
});

export { HoneyBadgerErrorBoundary as default };
//# sourceMappingURL=honeybadger-react.esm.js.map
